<template>
  <!-- 临时全灰色 -->
  <!-- <div id="app" style="-webkit-filter: grayscale(.95)"> -->
  
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view v-if="isRouterAlive"></router-view>
    <!--<router-view v-wechat-title="$route.meta.title"></router-view>-->
  </div>
</template>
<script src="https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.inc.min.js"></script>
<script>
export default {
  name: "App",
  provide () {
   return{
     reload: this.reload
   }
 },
 data() {
   return {
       isRouterAlive: true
   }
 },
 methods:{
   reload(){
     this.isRouterAlive = false
     this.$nextTick(function(){
       this.isRouterAlive = true
     })
   }
 },
  created() {},
  mounted() {},
};
</script>

<style>
@import "assets/style/common.css";
@import "assets/style/asset.css";

/* #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  } */
html,
body {
  /* background-color: #f7f7f7; */
  /* background-color: #f7f7f9; */
  height: 100%;
  margin: 0;
}

.el-message-box {
  width: 85% !important;
}

.el-message {
  min-width: 85% !important;
}
.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
  border: 1px solid #c0ccda;
}
.input-with-seach .el-input__inner {
  border-radius: 30px;
}
/* 首页角标样式 */
.homeInformation .el-badge .el-badge__content.is-fixed.is-dot {
  right: 13px !important;
  top: 8px !important;
}
  /* 新版首页中的el-drawe样式，写在界面中样式不生效 */
 ::v-deep.el-drawer__wrapper {
      z-index: -3000!important;
    }
    .el-drawer {
      width: 100% !important;
      height: 50% !important;
      font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue